module.exports = __webpack_public_path__ + "static/media/divider.4701acc4.png";